module.exports = __webpack_public_path__ + "static/media/variation.9d176ed1.png";